export const paramsToValuesArray = (params: Record<any, any>) =>
  Object.keys(params).map((key) => params[key])
